<template>
    <v-dialog
        v-model="$store.state.undefined.edit"
        max-width="500px"
    >
    <v-card>
        <v-toolbar dark color="secondary" dense>
            <v-spacer />
            <v-toolbar-title class="white--text"
                >Edit Unfinalized Cause</v-toolbar-title
            >
            <v-spacer></v-spacer>
                <v-btn
                    dark
                    icon
                    left
                    @click="$store.state.undefined.edit = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
        </v-toolbar>
        <v-container grid-list-xs fluid>
          <v-form ref="form" lazy-validation >
            <v-text-field label="Cause"  v-model="cause" 
                            :rules="[v => !!v || 'Required']" required></v-text-field>
          </v-form>
          <v-row justify="end">
            <v-btn class="mx-4 my-2" @click="validate" color="primary">Save</v-btn>
          </v-row>
        </v-container>
    </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    props: ['data'],
    data: function() {
        return {
            cause: ''
        };
    },
    mounted() {
        console.log(this.data);
        this.cause= this.data.Cause;
    },
    methods: {
        validate() {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
             this.editUnfinalizedCause();
            }
        },
        editUnfinalizedCause: function() {
            var str = this.$store;
            str.state.isLoading = true;
            var params = {
                Cause : this.cause,
            }
            axios
                .put('unifinalized-cause/update/'+this.data.ID,params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    str.state.isLoading = false;
                    this.$store.state.undefined.watch = true;
                    this.$store.state.undefined.edit = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                        str.state.isLoading = false;
                    }
                });
        }
    }
};
</script>
